import get from 'lodash/get'

export const getDeploymentStatus = (deployment) => {
  if (!deployment) return null
  return get(deployment, 'status', null)
}

export const getDeploymentStatusColor = (status) => {
  switch (status) {
    case 'deployed':
      return 'success'
    case 'running':
      return 'warning'
    case 'failed':
      return 'error'
    default:
      return 'default'
  }
}
